import { render } from "./MyInvestments.vue?vue&type=template&id=c521c0be&scoped=true"
import script from "./MyInvestments.vue?vue&type=script&lang=js"
export * from "./MyInvestments.vue?vue&type=script&lang=js"

import "./MyInvestments.vue?vue&type=style&index=0&id=c521c0be&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c521c0be"]])

export default __exports__